export default __webpack_public_path__ + "static/media/bursaries@3x.97340d8f.png";